import { Component, OnInit } from '@angular/core';
import { SsoService } from '@devinforius/i-sso';
import { DataService } from 'src/app/shared/services/data.service';
import * as _ from 'underscore';
import { HttpClient } from '@angular/common/http';
import { DialogReleasesNotesComponent } from '../dialog-releases-notes/dialog-releases-notes.component';
import { DialogService } from 'primeng/dynamicdialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ParamsService } from 'src/app/shared/services/params.service';
import { ArchivageModalsComponent } from 'src/app/components/modals/archivage-modals/archivage-modals.component';
import { ToastrService } from 'ngx-toastr';
import { NavbarNotification } from 'src/app/shared/models/notif';
import { GuardConfirmModalComponent } from 'src/app/components/modals/guard-confirm-modal/guard-confirm-modal.component';
import { TenantInfo } from 'src/app/shared/models/tenant-info';
import { TranslateService } from '@devinforius/i-essentials';
import { environment } from 'src/environments/environment';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { NotifMailSearchDTOPaginate } from 'src/app/shared/interfaces';
import { UserInfo } from 'src/app/shared/models/iCourrier/me/user-info';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { openWindow } from 'src/app/utils/open-window.utils';
import { iAdminService } from 'src/app/shared/services/i-admin.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { SignalrService } from 'src/app/shared/services/signalr.service';
import { MeRightMailGlobal } from 'src/app/shared/models/iCourrier/me/right-mail-global';
import { MailsService } from 'src/app/shared/services/mails.service';
import { MeService } from 'src/app/shared/services/me.service';
import { Router } from '@angular/router';
import { LATEST_LOCAL_VERSION } from 'src/app/shared/models/assistance/local-release-notes';
import { MailMeCountFilesDTO } from 'src/app/shared/models/mails/mail-me-count';
import { RightManagement } from 'src/app/shared/models/iCourrier/right/right-management';
import { INavbarConf, INavbarLink, INavbarOption } from '@devinforius/i-essentials/lib/interfaces';
import { Contact } from 'src/app/shared/models/iContact/contact/contact';
import { forkJoin, of } from 'rxjs';

@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.scss'],
})
export class PrivateComponent implements OnInit {
  public user: Contact & { avatar?: string | SafeUrl };
  public logout: () => unknown;

  public iNavLinks: INavbarLink[] = [
    {
      label: 'mainNav.mails',
      icon: 'bi bi-envelope-open-fill',
      command: () => {
        this.router.navigateByUrl('/private/ic/courriers', {
          state: { isScan: false },
        });
      },
      children: [],
    },
    {
      label: 'mainNav.search',
      icon: 'bi bi-search',
      command: () => {
        this.router.navigateByUrl('/private/ic/advSearch');
      },
    },
    {
      label: 'mainNav.actions',
      icon: 'bi bi-lightning-fill',
      command: () => {
        this.router.navigateByUrl('/private/ic/actions');
      },
    },
    {
      label: 'mainNav.reports',
      icon: 'bi bi-journal-text',
      command: () => {
        this.router.navigateByUrl('/private/ic/reporting');
      },
    },
    {
      label: 'mainNav.contacts',
      icon: 'bi bi-person-vcard',
      command: () => {
        this.router.navigateByUrl('/private/ic/contacts');
      },
    },
  ];

  public image: string = './assets/img/inforius.png';
  public appConfig: ConfigDto;
  public clientType: string = sessionStorage.getItem('clientType');
  public notifications: NavbarNotification[] = [];
  public countFiles: MailMeCountFilesDTO = null;
  public hasActionsCount = false;

  public tenantInfos: TenantInfo = null; //* Will receive all the infos about the tenant the user's in

  private rightManagementInfos: RightManagement;
  public userInfos: UserInfo;

  public navbarConfig: INavbarConf;
  public isLoaded = false;

  public themeName = '';

  constructor(
    private router: Router,
    private ssoService: SsoService,
    private dataService: DataService,
    public sanitizer: DomSanitizer,
    public params: ParamsService,
    public http: HttpClient,
    public dialogService: DialogService,
    public toastr: ToastrService,
    public translater: TranslateService,
    private contactsService: ContactsService,
    private iAdminService: iAdminService,
    private configService: ConfigService,
    private signalrService: SignalrService,
    private mailsService: MailsService,
    private meService: MeService
  ) { }

  ngOnInit(): void {
    this.themeName = null;
    this.getNavLinkTranslations();
    localStorage.removeItem('bacsIds');
    this.setVersion();
    this.logout = () => {
      this.logoutFct();
    };

    forkJoin({
      user: this.meService.getUserInfo().pipe(
        tap((res: UserInfo) => {
          this.userInfos = res;
        }),
        switchMap((res: UserInfo) => this.contactsService.fetchContact(res.contactId, 'iAdmin')),
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération du contact!');
          return of(null);
        })
      ),
      avatar: this.params.getAvatar().pipe(
        catchError(() => {
          this.user.avatar = './assets/img/avatar.svg';
          return of(null);
        })
      ),
      tenant: this.iAdminService.getTenant().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération du tenant!');
          return of(null);
        })
      ),
      countFiles: this.mailsService.getMailsCountFiles('DocAValider,DocASigner').pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération des compteurs de documents!');
          return of(null);
        })
      ),
      logo: this.configService.getLogoConfig().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération du logo!');
          return of(null);
        })
      ),
      notifications: this.meService.getNotifications({ read: false }).pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération des notifications!');
          return of(null);
        })
      ),
      config: this.configService.fetchConfig().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération des configurations!');
          return of(null);
        })
      ),
      rightManagement: this.meService.rightManagement().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération des droits!');
          return of(null);
        })
      ),
      rightsMail: this.meService.rightMailGlobal().pipe(
        catchError(() => {
          this.toastr.error('Une erreur est survenue dans la récupération des droits du mail!');
          return of(null);
        })
      ),
    }).subscribe((value) => {
      this.user = new Contact(value.user);
      this.setAvatar(value.avatar);
      this.tenantInfos = value.tenant;
      this.countFiles = value.countFiles;
      this.setLogo(value.logo);
      this.formatNotifications(value.notifications);
      this.setDatasWithConfig(value.config);
      this.rightManagementInfos = value.rightManagement;
      this.setiAdminMenu();
      this.setINavBarLinks(value.rightsMail);

      if (localStorage.getItem('iCourrier_point_id_send') !== null) {
        this.toastr.info("Création d'un courrier depuis iDelibe, redirection vers l'écran de création");
        this.router.navigateByUrl('/private/ic/new-from-idelibe');
      }

      this.signalrService.register();
      this.signalrService.startConnection(
        () => { },
        () => { }
      );
      this.setNavbarConfig();
      this.isLoaded = true;
    });
  }

  private setAvatar(avatar: Blob): void {
    if (avatar) {
      this.user.avatar = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(avatar));
    } else {
      this.user.avatar = './assets/img/avatar.svg';
    }
  }

  private setLogo(logo: Blob): void {
    if (logo) {
      this.image = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(logo)) as string;
    } else {
      this.image = './assets/img/inforius.png';
    }
  }

  private formatNotifications(notifications: NotifMailSearchDTOPaginate): void {
    this.notifications = [];
    if (notifications?.items?.length > 0) {
      this.notifications = notifications.items.map((x) => new NavbarNotification(x, this.translater));
      this.notifications.map((item) => {
        if (!item.isRead) {
          item.actionClick = () => {
            this.markAsRead([item]);
          };
        }
        item.linkClick = () => {
          const url = '/private/ic/tabs/';
          const config = environment;
          window.open(config.baseUrl + url + item.courrierId);
          this.markAsRead([item]);
        };
      });
      this.notifications = [...this.notifications];
      this.navbarConfig = { ...this.navbarConfig, notifications: this.notifications };
    }
  }

  private setDatasWithConfig(config: ConfigDto): void {
    this.themeName = config.theme === null ? 'default' : config.theme;
    this.appConfig = config;
    this.dataService.setConfigApp(this.appConfig);
    if (!sessionStorage.getItem('clientType')) {
      sessionStorage.setItem('clientType', this.appConfig.clientType);
    }
    this.openReleaseNotesDialog();
    if (this.appConfig.connecteurs?.isExchangeConfigured) {
      _.first(this.iNavLinks).children.push({
        label: this.translater.translate('mainNav.emails'),
        icon: 'bi bi-mailbox',
        command: () => {
          this.router.navigateByUrl('/private/ic/courriers-exchange');
        },
      });
    }
    if (this.appConfig.connecteurs?.office365?.isConfigured) {
      sessionStorage.setItem('office365', JSON.stringify(this.appConfig.connecteurs.office365));
      _.first(this.iNavLinks).children.push({
        label: this.translater.translate('mainNav.microsoft365'),
        icon: 'bi bi-inbox-fill',
        command: () => {
          this.router.navigateByUrl('/private/ic/courriers-365-home');
        },
      });
    }
  }

  private setiAdminMenu(): void {
    if (this.rightManagementInfos.viewMenuIAdmin) {
      this.manageiAdminMenu();
    } else {
      this.iNavLinks = this.iNavLinks.filter((menu) => menu.label !== this.translater.translate('mainNav.administration'));
    }
  }

  private setINavBarLinks(right: MeRightMailGlobal): void {
    _.first(this.iNavLinks).children.push({
      label: this.translater.translate('mainNav.lockedMails'),
      icon: 'bi bi-person-lock',
      command: () => {
        this.router.navigateByUrl('/private/ic/locked/courriers');
      },
    });
    if (right.menu.validationDocuments) {
      _.first(this.iNavLinks).children.push({
        label: this.countFiles?.aValider
          ? this.translater.translate('mainNav.documentsToValidateCount', { countFiles: this.countFiles.aValider })
          : this.translater.translate('mainNav.documentsToValidate'),
        icon: 'bi bi-check-circle',
        command: () => {
          this.router.navigateByUrl('/private/ic/document/to-validate');
        },
      });
    }
    if (sessionStorage.getItem('clientType') !== 'JVS') {
      if (right.menu.signatureDocuments) {
        _.first(this.iNavLinks).children.push({
          label: this.countFiles?.aSigner
            ? this.translater.translate('mainNav.documentsToSignCount', { countFiles: this.countFiles.aSigner })
            : this.translater.translate('mainNav.documentsToSign'),
          icon: 'bi bi-pen-fill',
          command: () => {
            this.router.navigateByUrl('/private/ic/document/to-sign');
          },
        });
      }
    }
    if (right.menu.scanningArchivage) {
      _.first(this.iNavLinks).children.push({
        label: this.translater.translate('mainNav.quickArchiving'),
        icon: 'bi bi-star-fill',
        command: () => {
          this.openArchiveRapide();
        },
      });

      const index = this.iNavLinks.map((x) => x.label).indexOf(this.translater.translate('mainNav.iScan'));
      if (index === -1) {
        this.iNavLinks.splice(this.iNavLinks.length - 2, 0, {
          label: this.translater.translate('mainNav.iScan'),
          icon: 'logo__scanner logo__scanner--white',
          command: () => {
            this.router.navigateByUrl('/private/ic/home-scans');
          },
        });
        this.iNavLinks = [...this.iNavLinks];
      }
    }
  }

  private getNavLinkTranslations(): void {
    this.iNavLinks.map((navLink) => {
      navLink.label = this.translater.translate(navLink.label);
    });
  }

  private setNavbarConfig() {
    const navbarConfig: INavbarConf = {
      options: [...this.getNavbarOptions(this.translater, this.clientType)],
      langs: ['FR', 'NL', 'DE', 'EN'],
      user: this.user,
      app: 'iCourrier',
      home: this.tenantInfos?.name,
      environment: !environment.production ? (environment.environmentTitle as 'DEV' | 'ACC' | 'PROD' | 'LCL') : undefined,
      links: [...this.iNavLinks],
      version: '6.2.0',

      toAssistance: () => {
        this.router.navigateByUrl('/private/ic/assistance');
      },
      notifications: this.notifications,
    };
    this.navbarConfig = navbarConfig;
  }
  getNavbarOptions(translate: TranslateService, clientType: string): INavbarOption[] {
    const options = [
      // {
      //   label: translate.translate('navbar.changeAccount'),
      //   icon: 'bi bi-person-circle me-2',
      //   command: () => {
      //     this.changeAccount();
      //   },
      // },
      {
        label: translate.translate('navbar.profile'),
        icon: 'bi bi-person-fill me-2',
        command: () => {
          this.openProfil();
        },
      },
      {
        label: translate.translate('navbar.disconnect'),
        icon: 'bi bi-power me-2',
        command: () => {
          this.logoutFct();
        },
      },
    ];
    if (clientType !== 'JVS') {
      options.splice(options.length - 1, 0, {
        label: translate.translate('navbar.accessDelegation'),
        icon: 'bi bi-person-fill-up me-2',
        command: () => {
          this.delegationAcces();
        },
      });
    }
    return options;
  }

  setVersion(): void {
    this.dataService.getversiongApp.subscribe({
      next: (res) => {
        if (res === null) {
          this.dataService.setVersionApp('6.2.0');
        }
      },
    });
  }

  public logoutFct(): void {
    if (sessionStorage.getItem('tryToQuit') !== '1') {
      this.ssoService.logOut();
      localStorage.removeItem('iCourrierBoxes');
      sessionStorage.clear();
      this.router.navigate(['/public/home']);
    } else {
      const ref = this.dialogService.open(GuardConfirmModalComponent, {
        header: 'Confirmation',
        styleClass: 'super-compos-modal-content confirm-inforius',
        dismissableMask: false,
        width: '30em',
        data: {
          message: 'Etes-vous sûr de vouloir quitter et perdre vos changements ?',
        },
      });
      ref.onClose.subscribe({
        next: (value) => {
          if (value) {
            if (value === true) {
              this.ssoService.logOut();
              localStorage.removeItem('iCourrierBoxes');
              sessionStorage.clear();
              this.router.navigate(['/public/home']);
              sessionStorage.removeItem('tryToQuit');
            }
          }
        },
      });
    }
  }

  public changeAccount(): void {
    const config = environment;
    if (sessionStorage.getItem('tryToQuit') !== '1') {
      window.location.href = `${config.issuer}/Account/SwitchUsername?clientId=${config.clientId
        }&redirectUri=${encodeURIComponent(config.postLogoutRedirectUri)}`;
      sessionStorage.clear();
      localStorage.removeItem('iCourrierBoxes');
    } else {
      const ref = this.dialogService.open(GuardConfirmModalComponent, {
        header: 'Confirmation',
        styleClass: 'super-compos-modal-content confirm-inforius',
        dismissableMask: false,
        width: '30em',
        data: {
          message: 'Etes-vous sûr de vouloir quitter et perdre vos changements ?',
        },
      });
      ref.onClose.subscribe({
        next: (value) => {
          if (value) {
            if (value === true) {
              window.location.href = `${config.issuer}/Account/SwitchUsername?clientId=${config.clientId
                }&redirectUri=${encodeURIComponent(config.postLogoutRedirectUri)}`;
              sessionStorage.clear();
              localStorage.removeItem('iCourrierBoxes');
              sessionStorage.removeItem('tryToQuit');
            }
          }
        },
      });
    }
  }

  public delegationAcces(): void {
    const config = environment;

    window.location.href = `${config.issuer}/Support/DelegationRequests?clientid=${config.clientId
      }&clientUri=${encodeURIComponent(config.postLogoutRedirectUri)}`;
  }

  openProfil(): void {
    if (sessionStorage.getItem('tryToQuit') !== '1') {
      this.router.navigateByUrl('/private/ic/profil');
    } else {
      const ref = this.dialogService.open(GuardConfirmModalComponent, {
        header: 'Confirmation',
        styleClass: 'super-compos-modal-content confirm-inforius',
        dismissableMask: false,
        width: '30em',
        data: {
          message: 'Etes-vous sûr de vouloir quitter et perdre vos changements ?',
        },
      });
      ref.onClose.subscribe({
        next: (value) => {
          if (value) {
            if (value === true) {
              this.router.navigateByUrl('/private/ic/profil');
              sessionStorage.removeItem('tryToQuit');
            }
          }
        },
      });
    }
  }
  private manageiAdminMenu(): void {
    // Une fois ici on a déjà le droit de vision du point de menu de iAdmin

    // On récupère l'existence du point de menu de iAdmin
    const iAdminLink = this.iNavLinks.find((link) => {
      return link.label === this.translater.translate('mainNav.administration');
    });
    // S'il n'existe pas on l'ajoute
    if (!iAdminLink) {
      this.iNavLinks.push({
        label: this.translater.translate('mainNav.administration'),
        icon: 'bi bi-person-fill-gear',
        command: () => {
          this.openAdmin();
        },
        children: [],
      });
    }
  }

  openAdmin(): void {
    openWindow(environment.frontIAdminUrl, this.toastr);
  }

  openReleaseNotesDialog = () => {
    // Tu noteras qu'on ne fait le check QUE ici :) ... comme ca on peut toujours l'ouvrir dans assistance
    if (environment.production) {
      const last_version_loaded = localStorage.getItem('last_version_loaded');
      if (last_version_loaded !== LATEST_LOCAL_VERSION) {
        const dialog = this.dialogService.open(DialogReleasesNotesComponent, {
          closable: false,
          width: '60vw',
          data: {
            actualVersion: last_version_loaded,
          },
        });
        dialog.onClose.subscribe({
          next: () => {
            localStorage.setItem('last_version_loaded', LATEST_LOCAL_VERSION);
          },
        });
      }
    }
  };

  openArchiveRapide(): void {
    this.dialogService.open(ArchivageModalsComponent, {
      header: 'Archivage rapide',
      styleClass: 'super-compos-modal-content fullwidth',
      showHeader: false,
      width: '50vw',
      dismissableMask: false,
    });
  }

  markAllNotificationsAsRead(): void {
    this.markAsRead(this.notifications);
  }

  markAsRead(items: NavbarNotification[]): void {
    if (items?.length > 0) {
      const data = {
        ids: items.map((item) => item.actionId),
      };
      this.meService.markReadNotification(data).subscribe({
        next: () => {
          this.toastr.success('Notification marquée comme lu');
          this.meService.getNotifications({ read: false }).subscribe({
            next: (res) => {
              this.formatNotifications(res);
            },
          });
        },
      });
    }
  }

  receive_langChg(lang): void {
    this.translater.setCurrentLang(lang.toLowerCase());
    localStorage.setItem('lang', lang.toLowerCase());
  }
}
